import React, { useState, useEffect, useRef, useContext } from 'react';
import { Button } from 'primereact/button';
import { FiSearch } from "react-icons/fi";

//NEW
import AuthContext from  "../../context/AuthContext";
import { GetUnits } from 'services/user/user.service';
import { InputField } from "components/InputField/Input";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { ReportDownloadByCategoryVsBrand } from 'services/report/report.service';
import { GetPermissions } from 'services/user/user.service';
import { Table } from 'components/Table/Table';
import { TextColumn } from 'components/Table/ColumnTemplates/CustomColumn';

const ReportByCategoriesVsBrand = () => {

    const { reportListByCategoryVsBrand, reportListByCategoryVsBrandLoading } = useSelector((state) => state.reportListByCategoryVsBrand);
    const { unitList } = useSelector((state) => state.units);
    const [autoUnitFilteredValue, setAutoUnitFilteredValue] = useState([]);

    const [showForm, setShowForm] = useState(false); //* state for form modal

    const [updateData, setUpdateData] = useState(null); // * state for update data

    // Get FrontEndPermission
    const { permissionList, permissionListLoading } = useSelector((state) => state.permissionList);
    const { user } = useContext(AuthContext);

    const ref = useRef(null);
    // * intitial value for create division state
    const createInitialValue = {
        id: 0,
        unit: "",
    };

    const formik = useFormik({
        initialValues: createInitialValue, // * if state is update then updateData state value will show up
        onSubmit: (values) => {
            const modified = {
                ...values,
                unit: parseInt(values?.unit?.id) || null,
            }
            handelSubmit(modified);
        },
        enableReinitialize: true,
    });

    const [selectedData, setSelectedData] = useState([])
    const dispatch = useDispatch();

    // form submit handler
    const handelSubmit = async (data) => {
        await dispatch(ReportDownloadByCategoryVsBrand(data)).then(() => {
            hideModal();
            return
        });
    };

    // modal hide function
    const hideModal = () => {
        setUpdateData(null); // * set updateData state to null to get latest update after when press again
        resetForm(); // * reset the form state
    };

    // reset form function
    const resetForm = () => {
        formik.resetForm();
    };

    useEffect(() => {
        dispatch(GetUnits());
        dispatch(ReportDownloadByCategoryVsBrand({
            unit: null,
        }));
    }, []);

    useEffect(() => {
        dispatch(GetPermissions());
    }, [user, ])

    const searchUnit = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && unitList !== undefined) {
                setAutoUnitFilteredValue([...unitList]);
            } else {
                setAutoUnitFilteredValue(
                    unitList?.filter((unit) => {
                        return unit?.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    // columns of the table with header name
    const generatedTableColumns = (data)=>{
        const keys = Object.keys(data)
        return keys.map(key => ({
            field: key,
            header: key,
            sortableBody: TextColumn,
            frozen: key === 'Category' ? true : false,
        }))
    }

    if(reportListByCategoryVsBrand?.[0]){
        var customColumns = generatedTableColumns(reportListByCategoryVsBrand?.[0])
    }

    // * input data array of object for the form / modal
    const inputData = [
        {
            id: "unit",
            name: "unit",
            type: "select",
            labelFor: "unit",
            label: "Select Unit",
            required: false,
            className: "col-12 md:col-2",
            width: '-webkit-fill-available',
            autoFilteredValue: autoUnitFilteredValue,
            autoCompleteMethod: searchUnit,
            selectedAutoValue: unitList,
        },
    ];

    return (
        <>
            <form onSubmit={formik.handleSubmit} ref={ref} className={`grid mt-2`}>
                
                {inputData.map(({ id, name, value, type, labelFor, label, required, rows, className, autoCompleteMethod, autoFilteredValue, onBlur, onChange, errors, ...rest }) => (
                        
                    <div key={id} className={`p-field ${className}`} >
                        <InputField
                            id={id}
                            type={type}
                            required={required}
                            name={name}
                            errors={errors || formik.errors?.[id]?.id || formik.errors[id]}
                            label={label}
                            labelFor={labelFor}
                            rows={rows}
                            value={formik.values[name]}
                            autoCompleteMethod={autoCompleteMethod}
                            autoFilteredValue={autoFilteredValue}
                            onChange={(...args) => {
                                !onChange && formik.handleChange(...args);
                                onChange?.(...args);
                            }}
                            onBlur={onBlur}
                            onClose={() => formik.setErrors({})}
                            {...rest}
                        />
                    </div>
                ))}
                <div className={`p-field col-12 md:col-3`} >
                    <Button 
                        type='submit'
                        label={ reportListByCategoryVsBrandLoading ? 'Data are Loading. Please wait!' : 'Search'}
                        loading={reportListByCategoryVsBrandLoading}
                        style={{'width': "100%"}}
                        icon={<FiSearch className="text-3xl mr-2" />}
                    />
                </div>
                
            </form>
            
            <Table
                //data
                tableHeaderName="Report By Category Vs Brand"
                tableColumns={customColumns}
                data={reportListByCategoryVsBrand}
                loading={reportListByCategoryVsBrandLoading}
                dataKey="id"
                rows={25}
                sortable
                searchField
                isRowSelectable
                scrollable
                scrollHeight = '700px'
                toolbarPermissions={permissionList[0]}
                exportBtn
                hideLeftToolbar
                selectedData = {selectedData}
                setSelectedData = {setSelectedData}
                setShowCreateModal={setShowForm}
            />
        </>
    );
};

export default ReportByCategoriesVsBrand;
